import Icon from "./Icon.jsx";

export default function Lesson({ lesson, onDone }) {
  return (
    <div className="page fade-up" style={{ maxWidth: 780 }}>
      <div style={{ marginBottom: 12 }}>
        <span className="eyebrow">{lesson.unit}</span>
      </div>
      <h1
        className="serif"
        style={{
          fontSize: 56,
          margin: "0 0 12px",
          letterSpacing: "-0.02em",
          lineHeight: 1.02,
        }}
      >
        {lesson.title}
      </h1>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          marginBottom: 40,
          color: "var(--ink-3)",
          fontSize: 13,
        }}
      >
        <Icon name="book" size={14} />
        <span>{lesson.readingMinutes} min read</span>
        <span>·</span>
        <span>Then: 5 exercises</span>
      </div>

      {lesson.sections.map((s, i) => (
        <Section key={i} section={s} />
      ))}

      <div
        style={{
          marginTop: 48,
          display: "flex",
          gap: 10,
          justifyContent: "space-between",
          alignItems: "center",
          padding: "24px 0",
          borderTop: "1px solid var(--line)",
          flexWrap: "wrap",
        }}
      >
        <div style={{ color: "var(--ink-3)", fontSize: 14 }}>
          Ready? Practice earns you <strong>gems</strong> and <strong>XP</strong>. Don't worry — hearts refill.
        </div>
        <button className="btn btn-terracotta" onClick={onDone}>
          Start practice <Icon name="arrow-right" size={14} color="#fff" />
        </button>
      </div>
    </div>
  );
}

function Section({ section }) {
  if (section.kind === "h")
    return (
      <h2
        className="serif"
        style={{ fontSize: 30, letterSpacing: "-0.01em", marginTop: 40, marginBottom: 14 }}
      >
        {section.text}
      </h2>
    );
  if (section.kind === "p")
    return (
      <p style={{ fontSize: 17, lineHeight: 1.65, color: "var(--ink-2)", marginBottom: 16 }}>
        {section.text}
      </p>
    );
  if (section.kind === "list")
    return (
      <ul style={{ listStyle: "none", padding: 0, margin: "8px 0 20px" }}>
        {section.items.map((it, i) => (
          <li
            key={i}
            style={{
              display: "flex",
              gap: 14,
              padding: "12px 0",
              borderBottom: "1px solid var(--line)",
            }}
          >
            <span
              style={{
                color: "var(--terracotta)",
                fontFamily: "var(--font-serif)",
                fontSize: 22,
                lineHeight: 1,
              }}
            >
              ◆
            </span>
            <div>
              <strong>{it.b}</strong> <span style={{ color: "var(--ink-3)" }}>{it.r}</span>
            </div>
          </li>
        ))}
      </ul>
    );
  if (section.kind === "callout")
    return (
      <div
        style={{
          borderLeft: "3px solid var(--terracotta)",
          padding: "14px 18px",
          background: "var(--terracotta-wash)",
          borderRadius: "0 10px 10px 0",
          margin: "24px 0",
        }}
      >
        <div className="eyebrow" style={{ color: "var(--terracotta-3)", marginBottom: 6 }}>
          {section.label}
        </div>
        <div
          style={{
            color: "var(--ink)",
            fontStyle: "italic",
            fontFamily: "var(--font-serif)",
            fontSize: 22,
            lineHeight: 1.4,
          }}
        >
          {section.text}
        </div>
      </div>
    );
  if (section.kind === "tip")
    return (
      <div
        style={{
          display: "flex",
          gap: 12,
          alignItems: "center",
          background: "var(--gem-wash)",
          padding: "12px 16px",
          borderRadius: 10,
          margin: "16px 0",
          fontSize: 14,
          color: "var(--ink-2)",
        }}
      >
        <Icon name="sparkle" size={16} color="#2F5562" />
        <span>{section.text}</span>
      </div>
    );
  if (section.kind === "compare")
    return (
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "1fr 1fr",
          gap: 14,
          margin: "20px 0",
        }}
      >
        <div
          style={{
            border: "1px solid var(--line)",
            borderRadius: 12,
            overflow: "hidden",
            background: "#FBF7F0",
          }}
        >
          <div
            style={{
              background: "#F4E0D9",
              padding: "8px 14px",
              fontSize: 12,
              fontWeight: 600,
              color: "#8A2A2A",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <Icon name="x" size={14} color="#8A2A2A" strokeWidth={2.4} /> Vague
          </div>
          <div
            className="mono"
            style={{
              padding: 14,
              fontSize: 13,
              whiteSpace: "pre-wrap",
              color: "var(--ink-2)",
            }}
          >
            {section.bad}
          </div>
        </div>
        <div
          style={{
            border: "1px solid var(--moss)",
            borderRadius: 12,
            overflow: "hidden",
            background: "#FBF7F0",
          }}
        >
          <div
            style={{
              background: "var(--moss-wash)",
              padding: "8px 14px",
              fontSize: 12,
              fontWeight: 600,
              color: "#3E5940",
              display: "flex",
              alignItems: "center",
              gap: 6,
            }}
          >
            <Icon name="check" size={14} color="#3E5940" strokeWidth={2.4} /> Clear
          </div>
          <div
            className="mono"
            style={{
              padding: 14,
              fontSize: 13,
              whiteSpace: "pre-wrap",
              color: "var(--ink-2)",
            }}
          >
            {section.good}
          </div>
        </div>
      </div>
    );
  return null;
}
